var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("Welcome to "),_c('b',[_vm._v("Vue LBD PRO")]),_vm._v(" - a beautiful freebie for every web developer. "+_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }